const s = {
  cssVarPrefix: "kmx-mui"
};
export {
  s as default
};
